import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';
import { loadTranslations } from '@angular/localize';
import { Configuration } from 'src/app/shared/configuration';
import { CacheService } from 'src/app/shared/services/cache.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private countrySource = new BehaviorSubject<string>('default-country');
  currentCountry = this.countrySource.asObservable();
  path: any;

  constructor(private httpService: HttpService, private cacheService: CacheService, private route: ActivatedRoute) { }

  setCountry(country: string): void {
    this.countrySource.next(country);
  }


  loadTranslationsData(route): Promise<any> {
    const { country, language } = route.params;

    if (language && language !== 'en') {
      return new Promise((resolve, reject) => {
        this.httpService.makeHttpGetCall('/assets/i18n/' + country + '/' + language + '.json').subscribe((res: any) => {
          loadTranslations(res.translations);
          this.cacheService.setTranslation(res.translations)
          $localize.locale = res.locale;
          resolve(true);
        });
      });
    }
  }


}


